import React from 'react'

import { BaseDivProps } from 'src/types'

function Footer({ className }: BaseDivProps) {
  return <div className={className}></div>
}

export default Footer
